module.exports = __webpack_public_path__ + "img/ojo.0f12f07e.svg";